import { call, select, takeLatest } from 'redux-saga/effects';
import { organisationUiActions as actions } from '.';
import {
  sagaRequestTemplate,
  sagaSpecialRequestTemplate,
} from 'utils/tools/slice-actions';
import { LEGISLATOR_MANAGEMENT_MODULE } from 'config/api-variables';
import { selectOfficeDetails } from 'modules/Authentication/slice/selectors';

function* fetchOrgUiDetails({ payload }) {
  yield call(
    sagaRequestTemplate,
    LEGISLATOR_MANAGEMENT_MODULE + '/ui/details',
    payload,
    actions,
    'fetchDashboardDataStartSuccess',
    'fetchActionError',
    'Unable to load dashboard data!',
    [false],
  );
}

function* manageOrgUiDetails({ payload }) {
  const { officeId } = yield select(selectOfficeDetails);

  yield call(
    sagaSpecialRequestTemplate,
    LEGISLATOR_MANAGEMENT_MODULE + '/ui/details/add',
    {
      organisation_office_id: officeId,
      ...payload,
    },
    actions,
    'updateActionEnd',
    'updateActionError',
    `There was a problem while updating UI details!`,
  );
}

export function* organisationUiSaga() {
  yield takeLatest(actions.fetchOrgUiDetailsStart.type, fetchOrgUiDetails);
  yield takeLatest(actions.manageOrgUiDetailsStart.type, manageOrgUiDetails);
}
